/*global VeloxGridAndFormController, VeloxWebView, veloxScriptLoader, VeloxFormController, moment*/
var Mustache = require("mustache");
var uuid = require("uuid");
var rho = require("rho");
var bluetooth = require("./bluetooth");
var Diag = require("../../util/diag") ;
var disinfExt = require("../../extensions/disinf") ;
var trTemplate = {
    "fr-FR" : require("../../views/reportTemplate/locales/fr-FR/translation.json"),
    "fr" : require("../../views/reportTemplate/locales/fr-FR/translation.json"),
    "es-ES" : require("../../views/reportTemplate/locales/es-ES/translation.json"),
    "en-GB" : require("../../views/reportTemplate/locales/en-GB/translation.json"),
    "de-DE" : require("../../views/reportTemplate/locales/de-DE/translation.json"),
    "de" : require("../../views/reportTemplate/locales/de-DE/translation.json")
} ;

var diagController = new VeloxGridAndFormController("diag", {
    grid : {
        directory: "views/diag",
        name: "diagGrid"
    },
    form : {
        buttonsHTML: "<!--no button-->",
        directory: "views/diag",
        name: "diagForm",
        defaultData : {
            d_date : new Date()
        },
        joinFetch : [
            { otherTable: "diag_custom_product", name: "customProducts", type: "2many", },
            { otherTable: "customer", type: "2one", joins: [
                { otherTable: "pool", type: "2one"},
                { otherTable: "spa", type: "2one"}
            ]},
        ]
    }
});

/**
 * Handle the different cases of data that can be receive :
 *  - diag id (from diag history)
 *  - customer id (create new diag for a customer)
 */
diagController.formController.prepareDataOnEnter = function(data, callback){
    this.api.api.multiread({ 
        reseller_settings : {
            searchFirst: {}
        }
    }, function(err, reads){
        if(err){ return callback(err) ;}

        if(data && data.d){ //receive diag id
            VeloxFormController.prototype.prepareDataOnEnter.call(this,data.d, callback) ;
        }else if(data && data.copy){//create from existing
            this.mode = "create" ;
            this.api.api.multiread({
                diag: {
                    getByPk : data.copy, 
                    joinFetch : [
                        { otherTable: "diag_custom_product", name: "customProducts", type: "2many", },
                        { otherTable: "customer", type: "2one", joins :[
                            { otherTable: "pool", type: "2one"},
                            { otherTable: "spa", type: "2one"}
                        ]}
                    ]
                }
            }, function(err, reads){
                if(err){ return callback(err); }
                this.currentRecord = reads.diag ;
                delete this.currentRecord.d_id;
                this.currentRecord.d_date = new Date() ;
                this.currentRecord.d_diag_price = reads.reseller_settings?reads.reseller_settings.rs_diag_price:"" ;
                callback(null, this.currentRecord);
            }.bind(this)) ;
        }else if(data && data.c && data.keepDiag){//receive customer id and diag to keep
            this.mode = "create" ;
            this.api.api.customer.getByPk(data.c, [
                { otherTable: "pool", type: "2one"},
                { otherTable: "spa", type: "2one"}
            ], function(err, customer){
                if(err){ return callback(err); }
                this.currentRecord = data.keepDiag ;
                this.currentRecord.customer = customer ;
                if(customer.pool && !customer.spa){
                    //this customer has only pool
                    this.currentRecord.d_pool_or_spa = "POOL";
                }else if(customer.spa && !customer.pool){
                    //this customer has only spa
                    this.currentRecord.d_pool_or_spa = "SPA";
                }else{
                    this.currentRecord.d_pool_or_spa = null;
                }
                this.currentRecord.d_date = new Date() ;
                this.currentRecord.d_diag_price = reads.reseller_settings?reads.reseller_settings.rs_diag_price:"" ;
                callback(null, this.currentRecord);
            }.bind(this)) ;
        }else if(data && data.c){//receive customer id
            this.mode = "create" ;
            this.api.api.customer.getByPk(data.c, [
                { otherTable: "pool", type: "2one"},
                { otherTable: "spa", type: "2one"}
            ], function(err, customer){
                if(err){ return callback(err); }
                this.currentRecord = { customer : customer } ;
                if(customer.pool && !customer.spa){
                    //this customer has only pool
                    this.currentRecord.d_pool_or_spa = "POOL";
                }else if(customer.spa && !customer.pool){
                    //this customer has only spa
                    this.currentRecord.d_pool_or_spa = "SPA";
                }else{
                    this.currentRecord.d_pool_or_spa = null;
                }
                this.currentRecord.d_date = new Date() ;
                this.currentRecord.d_diag_price = reads.reseller_settings?reads.reseller_settings.rs_diag_price:"" ;
                callback(null, this.currentRecord);
            }.bind(this)) ;
        }else{
            VeloxFormController.prototype.prepareDataOnEnter.call(this,data, function(err, dataRead){
                if(err){ return callback(err); }
                if(!dataRead){ throw "Can't get diag "+data }
                dataRead.d_date = new Date() ;
                dataRead.d_diag_price = reads.reseller_settings?reads.reseller_settings.rs_diag_price:"" ;
                callback(null, dataRead) ;
            }) ;
        }
    }.bind(this));
} ;

diagController.formController.onCustomerRemove = function(){
    this.updateRouteData(diagController.formController.viewOptions.route, "") ;
};
diagController.formController.onCustomerOpen = function(){
    this.navigate("/customer/form", {c: this.data.customer.c_id}) ;
};



/**
 * user chose pool or span mode
 */
diagController.formController.onBeforeRender = function(){
    if(this.data.d_pool_or_spa === "POOL"){
        document.getElementById("main").className = document.getElementById("main").className.replace(" spa", "") ;
    }else if(this.data.d_pool_or_spa === "SPA"){
        if(document.getElementById("main").className.indexOf("spa") === -1){
            document.getElementById("main").className += " spa" ;
        }
    }
    if(this.data.customer){
        if(this.data.d_pool_or_spa === "POOL"){
            this.data.p_volume = this.data.customer.pool.p_volume;
            this.data.p_filter = this.data.customer.pool.p_filter;
            this.data.p_extra_installation = this.data.customer.pool.p_extra_installation;
            this.data.p_pool_cover = this.data.customer.pool.p_pool_cover;
            this.data.p_pool_cover_other = this.data.customer.pool.p_pool_cover_other;
            this.data.p_regulation = this.data.customer.pool.p_regulation;
            this.data.p_regulation_other = this.data.customer.pool.p_regulation_other;
            this.data.p_electrolyzer = this.data.customer.pool.p_electrolyzer;
            this.data.p_electrolyzer_other = this.data.customer.pool.p_electrolyzer_other;
            this.data.p_ph_correction = this.data.customer.pool.p_ph_correction;
            this.data.p_alkalinity = this.data.customer.pool.p_alkalinity;
            this.data.p_hardness = this.data.customer.pool.p_hardness;
            this.data.p_disinfectant = this.data.customer.pool.p_disinfectant;
            this.data.p_disinf_shock = this.data.customer.pool.p_disinf_shock;
            this.data.p_disinf_long = this.data.customer.pool.p_disinf_long;
            this.data.p_disinf_salt_rate = this.data.customer.pool.p_disinf_salt_rate;
            this.data.p_algae = this.data.customer.pool.p_algae;
            this.data.p_flocculation = this.data.customer.pool.p_flocculation;
            this.data.p_cleaning = this.data.customer.pool.p_cleaning;
            this.data.p_filter_maintenance = this.data.customer.pool.p_filter_maintenance;
            this.data.p_wintering = this.data.customer.pool.p_wintering;
            this.data.p_advanced_other = this.data.customer.pool.p_advanced_other;            
            this.data.p_respect = this.data.customer.pool.p_respect;            
        }else if(this.data.d_pool_or_spa === "SPA"){
            this.data.s_volume = this.data.customer.spa.s_volume;
            this.data.s_spa_cover = this.data.customer.spa.s_spa_cover;
            this.data.s_spa_cover_other = this.data.customer.spa.s_spa_cover_other;
            this.data.s_filter = this.data.customer.spa.s_filter;
            this.data.s_electrolyzer = this.data.customer.spa.s_electrolyzer;
            this.data.s_electrolyzer_other = this.data.customer.spa.s_electrolyzer_other;
            this.data.s_extra_installation = this.data.customer.spa.s_extra_installation;
            this.data.s_regulation = this.data.customer.spa.s_regulation;
            this.data.s_regulation_other = this.data.customer.spa.s_regulation_other;
            this.data.s_water_balance = this.data.customer.spa.s_water_balance;
            this.data.s_disinfectant = this.data.customer.spa.s_disinfectant;
            this.data.s_disinf_shock = this.data.customer.spa.s_disinf_shock;
            this.data.s_disinf_long = this.data.customer.spa.s_disinf_long;
            this.data.s_disinf_salt_rate = this.data.customer.spa.s_disinf_salt_rate;
            this.data.s_other_product = this.data.customer.spa.s_other_product;
        }
    }
    this.data.hasSpinlab = window.native && window.native.spinlab ;
    this.data.hasBluetooth = !!window.ble ;
    this.data.hasPoolTester = window.cordova || navigator.bluetooth ;
    this.data.hasRespectProducts = false;
    if(VeloxWebView.i18n.getLang()  === "fr-FR" || VeloxWebView.i18n.getLang()  === "fr" ||
        VeloxWebView.i18n.getLang()  === "de-DE" || VeloxWebView.i18n.getLang()  === "de"){
        this.data.hasRespectProducts = true;
    }
} ;

diagController.formController.on("unstack", function(){
    diagController.formController.onBeforeRender() ;
}) ;

/**
 * Open the grid when user search
 * @param {*} ev 
 */
diagController.formController.onSearch = function(ev){
    var inputSearch = ev.data ;
    this.navigate("~customer/list", {s:inputSearch, d: ".."}) ;
} ;


/**
 * prepare diag data from input
 */
function getInputData(diag){
    var isPool = diag.d_pool_or_spa === "POOL" ;
    var hasElect = false ;
    var shock = [];
    var long = [];
    var disinf = isPool?diag.p_disinfectant:diag.s_disinfectant;
    var disinfFull = disinf;
    
    if(disinf === "CHLORINE"){
        disinf = "CL" ;
        shock = isPool?diag.p_disinf_shock:diag.s_disinf_shock ;
        long = isPool?diag.p_disinf_long:diag.s_disinf_long ;
    }else if(disinf === "BROMINE"){
        disinf = "BR" ;
        shock = isPool?diag.p_disinf_shock:diag.s_disinf_shock ;
        long = isPool?diag.p_disinf_long:diag.s_disinf_long ;
    }else if(disinf === "OXYGEN"){
        disinf = "O2" ;
        shock = isPool?diag.p_disinf_shock:diag.s_disinf_shock ;
        long = isPool?diag.p_disinf_long:diag.s_disinf_long ;
    }else if(disinf === "SALT"){
        disinf = "CL" ;
        disinfFull = "CHLORINE" ;
        shock = isPool?diag.p_disinf_shock:diag.s_disinf_shock ;
        hasElect = true ;
    }

    var regul = (isPool?diag.p_regulation:diag.s_regulation)||null ;
    if(!regul){
        var elect = (isPool?diag.p_electrolyzer:diag.s_electrolyzer)||null ;
        if(elect === "AUTOMATIC_SALT" || elect === "AUTOMATIC_SALT_AS5" || elect === "AUTOMATIC_SALT_AS7"){
            regul = elect;
        }
    }

    return {
        measures: {
            alk          : diag.d_alk          ,
            ph           : diag.d_ph           ,
            th           : diag.d_hardness     ,
            clFree       : diag.d_free_cl      ,
            clTotal      : diag.d_total_cl     ,
            br           : diag.d_br           ,
            salt         : diag.d_salt         ,
            salt_disolved: diag.d_salt_disolved,
            cu           : diag.d_cu           ,
            fe           : diag.d_fe           ,
            stab         : diag.d_stab         ,
            temp         : diag.d_temperature  ,
            oxygen       : diag.d_oxygen       ,
            phos         : diag.d_phosphate
        },
        options: {
            mode:               diag.d_mode,
            filterMaint:        diag.d_filter_maint||false,
            cleanLine:          diag.d_clean_line||false,
            startUp:            diag.d_startup||false,
            wintering:          diag.d_wintering||false,
            greenWaterAlgae:    diag.d_green_algae||false,
            greenWaterCrystal:  diag.d_green_water_crystal||false,
            troubleWater:       diag.d_trouble_water||false,
            mousse:             diag.d_mousse||false,
            mark:               diag.d_marks||false,
            markSpa:            diag.d_marks_spa||false
        },
        pool: {
            poolOrSpa:          diag.d_pool_or_spa.toLowerCase(),
            disinf:             disinf,
            disinfFull:         disinfFull,
            volume:             isPool?diag.p_volume:diag.s_volume,
            saltElect:          hasElect,
            saltRate:           (isPool?diag.p_disinf_salt_rate:diag.s_disinf_salt_rate)||0,
            filter:             (isPool?diag.p_filter:diag.s_filter)||null,
            regul:              regul,
            regul_other:        (isPool?diag.p_regulation_other:diag.s_regulation_other)||null,
            poolCover:          (isPool?diag.p_pool_cover:diag.s_spa_cover)||null,
            poolCover_other:    (isPool?diag.p_pool_cover_other:diag.s_spa_cover_other)||null,
            shock:              shock||[],
            long:               long||[],
            alg:                (isPool?diag.p_algae:null)||[],
            equip:              (isPool?diag.p_extra_installation:diag.s_extra_installation)||[],
            electrolyzer:       isPool?diag.p_electrolyzer:diag.s_electrolyzer,
            electrolyzer_other: isPool?diag.p_electrolyzer_other:diag.s_electrolyzer_other,
        },
        globalNotes:            diag.d_notes
    } ;
}

/**
 * product quantity compute rules
 */
var productQties = {
    "CHLORIKLAR"           : "x2",
    "CHLORIFIX"            : "x14",
    "CHLORYTE"             : "x3",
    "BAYROSHOCK"           : "x11",
    "BAYROXYSHOCK"         : "x11b",
    "BAYROSHOCK_LIGHT"     : "x11l",
    "AQUABROME_REGENERATOR": "x10",
    "CHLORILONG"           : "x8",
    "CHLORILONG_5F"        : "x7",
    "VARITAB"              : "x6",
    "CHLORILONG_BLOC"      : "x18",
    "CHLORILONG_EXTRA"     : "x8",
    "MULTIBLOC"            : "x19",
    "MULTILONG"            : "x20",
    "C_AND_E"              : "x21",
    "CHLORE_5F"            : "x4",
    "CHLORILIQUE_C"        : "",
    "S_AND_E_20"           : "x12",
    "S_AND_E_30"           : "x22",
    "SOFTSWIM_MULTI"       : "x23",
    "BAYROSOFT"            : "x24",
    "BAYROSOFT_LIGHT"      : "x24l",
    "DESALGINE"            : "x15",
    "DESALGINE_JET"        : "x13",
    "DESALGINE_MUSTARD"    : "x39",
    "CL_MINIPOOL"          : "x28mini",
    "CL_MICROBILLE"        : "x28",
    "CL_MICROBILLELONG"    : "x27",
    "CL_MINIPOOLLONG"      : "x27mini",
    "DISINF_PLUS"          : "x29",
    "BROME_SPATIME"        : "x30",
    "OXY_SPATIME"          : "x31",
    "ACTIVE_OXY_SPATIME"   : "x32",
    "CHLORYTE_STICKS"      : "x37",
    "CHLORIFIX_TAB"        : "x38",
    "AQUABROME_MINIPOOL"   : "x30mini",
    "POOL_DETOX"           : "x40",
    "NO_POLLEN"            : "x41",

};

/**
 * products translation codes
 */
var productTr = {
    "CHLORIKLAR"           : "fields.values.pool.p_disinf_shock.CHLORIKLAR",
    "CHLORIFIX"            : "fields.values.pool.p_disinf_shock.CHLORIFIX_MICRO",
    "CHLORIFIX_TAB"            : "fields.values.pool.p_disinf_shock.CHLORIFIX_TAB",
    "CHLORYTE"             : "fields.values.pool.p_disinf_shock.CHLORYTE",
    "BAYROSHOCK"           : "fields.values.pool.p_disinf_shock.BAYROSHOCK",
    "BAYROXYSHOCK"           : "fields.values.pool.p_disinf_shock.BAYROXYSHOCK",
    "BAYROSHOCK_LIGHT"     : "fields.values.pool.p_disinf_shock.BAYROSHOCK_LIGHT",
    "AQUABROME"            : "fields.values.pool.p_disinf_long.AQUABROME",
    "AQUABROME_REGENERATOR": "fields.values.pool.p_disinf_shock.AQUABROME_REGENERATOR",
    "CHLORILONG"           : "fields.values.pool.p_disinf_long.CHLORILONG_250",
    "CHLORILONG_5F"        : "fields.values.pool.p_disinf_long.CHLORILONG_5FUNC",
    "CHLORYTE_STICKS"      : "fields.values.pool.p_disinf_long.CHLORYTE_STICKS",
    "VARITAB"              : "fields.values.pool.p_disinf_long.VARITAB",
    "CHLORILONG_BLOC"      : "fields.values.pool.p_disinf_long.CHLORILONG_BLOC",
    "CHLORILONG_EXTRA"     : "fields.values.pool.p_disinf_long.CHLORILONG_EXTRA",
    "MULTIBLOC"            : "fields.values.pool.p_disinf_long.MULTIBLOC",
    "MULTILONG"            : "fields.values.pool.p_disinf_long.MULTILONG",
    "C_AND_E"              : "fields.values.pool.p_disinf_long.COMPLETE_EASY",
    "CHLORE_5F"            : "fields.values.pool.p_disinf_long.CHLORE_5F",
    "CHLORILIQUE_C"        : "fields.values.pool.p_disinf_long.CHLORILIQ_C",
    "S_AND_E_20"           : "fields.values.pool.p_disinf_long.SOFT_EASY_20",
    "S_AND_E_30"           : "fields.values.pool.p_disinf_long.SOFT_EASY_30",
    "SOFTSWIM_MULTI"       : "fields.values.pool.p_disinf_long.SOFT_SWIM_MULTI",
    "BAYROSOFT"            : "fields.values.pool.p_disinf_long.BAYROSOFT",
    "BAYROSOFT_LIGHT"      : "fields.values.pool.p_disinf_long.BAYROSOFT_LIGHT",
    "DESALGINE"            : "fields.values.pool.p_algae.DESALGINE",
    "DESALGINE_JET"        : "fields.values.pool.p_algae.DESALGINE_JET",
    "DESALGINE_MUSTARD"        : "fields.values.pool.p_algae.DESALGINE_MUSTARD",
    "FOUNTAIN"              : "fields.values.pool.p_extra_installation.FOUNTAIN",
    "CASCAD"                : "fields.values.pool.p_extra_installation.CASCAD",
    "SWIM_AGAINST"          : "fields.values.pool.p_extra_installation.SWIM_AGAINST",
    "INFINITY_POOL"        : "fields.values.pool.p_extra_installation.INFINITY_POOL",
    "OTHER"                 : "fields.values.pool.p_extra_installation.OTHER",
    "CL_MICROBILLE"         : "fields.values.spa.s_disinf_shock.CL_MICROBILLE",
    "CL_MICROBILLELONG"     : "fields.values.spa.s_disinf_long.CL_MICROBILLELONG",
    "DISINF_PLUS"           : "fields.values.spa.s_disinf_shock.DISINF_PLUS",
    "BROME_SPATIME"         : "fields.values.spa.s_disinf_long.BROME_SPATIME",
    "ACTIVE_OXY_SPATIME"    : "fields.values.spa.s_disinf_shock.ACTIVE_OXY_SPATIME",
    "OXY_SPATIME"           : "fields.values.spa.s_disinf_long.OXY_SPATIME",
    "AQUABROME_MINIPOOL"    : "fields.values.spa.s_disinf_long.AQUABROME_MINIPOOL",
    "CL_MINIPOOLLONG"    : "fields.values.spa.s_disinf_long.CL_MINIPOOLLONG",
    "CL_MINIPOOL"    : "fields.values.spa.s_disinf_shock.CL_MINIPOOL",
};

/**
 * Remove not allowed products following pool parameters
 *
 * @param array {Array} array of product code
 * @param input {object} diag input object
 */
function removeNotAllowedProducts(array, input){
    var result = [] ;
    array.forEach(function(product){
        if(product === "CHLORILONG") {
            if (input.pool.volume >= 15 && input.pool.volume <= 210) {
                result.push(product);
            }
        }else if(product === "CHLORILONG_EXTRA") {
            if (input.pool.volume >= 15 && input.pool.volume <= 210) {
                result.push(product);
            }
        }else if(product === "CHLORILONG_BLOC") {
            if (input.pool.volume >= 20 && input.pool.volume <= 210) {
                result.push(product);
            }
        }else if(product === "CHLORYTE_STICKS") {
            if (input.pool.volume >= 15 && input.pool.volume <= 120) {
                result.push(product);
            }
        }else if(product === "CHLORILONG_5F"){
            if(input.pool.volume >= 15 && input.pool.volume <= 210 &&
                ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product) ;
            }
        }else if(product === "CHLORE_5F"){
            if(input.pool.volume >= 0.6 && input.pool.volume < 15 &&
            ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "VARITAB"){
            if(input.pool.volume >= 20 && input.pool.volume <= 210 &&
            ["GLASS", "SAND"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "MULTIBLOC") {
            if(input.pool.volume >= 25 && input.pool.volume <= 210 &&
            ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "MULTILONG") {
            if(input.pool.volume >= 30 && input.pool.volume <= 200 &&
            ["GLASS", "SAND"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "S_AND_E_20") {
            if(input.pool.volume >= 11 && input.pool.volume <= 100 &&
            ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "S_AND_E_30") {
            if(input.pool.volume >= 21 && input.pool.volume <= 120 &&
            ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "C_AND_E") {
            if(input.pool.volume >= 11 && input.pool.volume <= 100 &&
                ["GLASS", "SAND", "CARTRIDGE", "POCKET"].indexOf(input.pool.filter) !== -1) {
                result.push(product);
            }
        }else if(product === "DISINF_PLUS") {
            if(input.pool.volume >= 0.21 && input.pool.volume <= 4.9) {
                result.push(product);
            }
        }else if(product === "BROME_SPATIME") {
            if(input.pool.volume >= 0.21 && input.pool.volume <= 10.2) {
                result.push(product);
            }
        }else if(product === "AQUABROME_MINIPOOL") {
            if(input.pool.volume >= 0.21 && input.pool.volume <= 10.2) {
                result.push(product);
            }
        }else if(product === "CHLORIFIX_TAB") {
            if(input.pool.volume >= 8 && input.pool.volume <= 110) {
                if(input.pool.disinf !== "O2" || !input.pool.long || input.pool.long.length !== 1 || input.pool.long[0] !== "BAYROSOFT_LIGHT") {
                    //if not oxygen or not only bayroft light (if only bayrosoft light don't add it)
                    result.push(product);
                }
            }
        }else if(product === "CHLORIKLAR" || product === "CHLORIFIX" ||product === "CHLORYTE") {
            if(input.options.mode === "ALG_MUSTARD" || input.options.mode === "ALG" 
                || input.options.mode === "TROUBLED"  || input.options.mode === "COLOR" 
                || input.pool.disinf !== "O2" || !input.pool.long || input.pool.long.length !== 1 || input.pool.long[0] !== "BAYROSOFT_LIGHT") {
                //if alg/troubled/color mode or not oxygen or not only bayroft light (if only bayrosoft light don't add it)
                result.push(product);
            }
        }else{
            result.push(product) ;
        }
    }) ;

    if(input.options.mode === "ALG_MUSTARD" && input.pool.disinf === "O2" && array.indexOf("CHLORIKLAR") !== -1){
        //MUSTARD MODE + oxygen + shock product, allow only "CHLORIKLAR", "CHLORIFIX" and "CHLORYTE"
        result = result.filter(function(product){
            return [
                "CHLORIKLAR", "CHLORIFIX", "CHLORYTE"
            ].indexOf(product) !== -1
        }) ;
    }

    return result.filter(function(p){
        //filter by country availability
        return disinfExt.COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }) ;
} ;

/**
 * Remove product that we can't use with regulation
 * @param array
 */
function removeNotRegulProducts(array){
    var result = [] ;
    array.forEach(function(product){
        if(product === "CHLORILONG") {
            result.push(product);
        }else if(product === "CHLORILIQUE_C") {
            result.push(product);
        }
    }) ;
    return result;
} ;

/**
* Aggregate all values of diag to create the template values
*
* @param diag
* @returns {object} flat values
*/
function aggregateValues(diag, fieldsValues, customerData, blockTemplates) {
    var values = {};
    Object.keys(diag.input.measures).forEach(function (k) {
        values[k] = diag.input.measures[k];
    });
    Object.keys(diag.input.options).forEach(function (k) {
        values[k] = diag.input.options[k];
    });
    Object.keys(diag.input.pool).forEach(function (k) {
        values[k] = diag.input.pool[k];
    });
    values.signs = {} ;

    values.signs.alk = fieldsValues.d_alk_sign || "";
    values.signs.ph = fieldsValues.d_ph_sign || "";
    values.signs.hardness = fieldsValues.d_hardness_sign || "";
    values.signs.freeCl = fieldsValues.d_free_cl_sign || "";
    values.signs.totalCl = fieldsValues.d_total_cl_sign || "";
    values.signs.bromine = fieldsValues.d_br_sign || "";
    values.signs.salt = fieldsValues.d_salt_sign || "";
    values.signs.oxygen = fieldsValues.d_oxygen_sign || "";
    values.signs.cu = fieldsValues.d_cu_sign || "";
    values.signs.fe = fieldsValues.d_fe_sign || "";
    values.signs.stab = fieldsValues.d_stab_sign || "";
    values.signs.phosphate = fieldsValues.d_phosphate_sign || "";
     
   Object.keys(diag.variables.references).forEach(function (k) {
       values[k] = diag.variables.references[k];
   });
   Object.keys(diag.variables.computed).forEach(function (k) {
       values[k] = diag.variables.computed[k];
   });
   Object.keys(diag.variables.dosage).forEach(function (k) {
       values[k] = diag.variables.dosage[k];
   });

   values.diagPrice = fieldsValues.d_diag_price ;
   values.diagUser = fieldsValues.d_diag_user ;
   values.date = moment(fieldsValues.d_date).format("L");

   //compute the "product1 OR product2..." parts
   

   var knownProductsChock = [];
   var knownProductsLong = [];
   var knownProductsLongRegul = [];

   if (diag.input.pool.disinf === "CL") {
       if(diag.input.pool.poolOrSpa === "pool"){
           knownProductsChock = removeNotAllowedProducts(["CHLORIKLAR", "CHLORIFIX","CHLORIFIX_TAB", "CHLORYTE"], diag.input);
           knownProductsLong = removeNotAllowedProducts(["CHLORILONG", "CHLORILONG_5F", "VARITAB", "CHLORILONG_EXTRA", "CHLORILONG_BLOC", "MULTIBLOC", "MULTILONG",
               "C_AND_E", "CHLORE_5F", "CHLORILIQUE_C", "CHLORYTE_STICKS"], diag.input);
           knownProductsLongRegul = removeNotAllowedProducts(["CHLORILONG", "CHLORILIQUE_C"], diag.input);
       }else{
           if(VeloxWebView.i18n.getLang() === "es-ES"){
               knownProductsChock = removeNotAllowedProducts(["CL_MINIPOOL"], diag.input);
               knownProductsLong = removeNotAllowedProducts(["CL_MINIPOOLLONG"], diag.input);
            }else{
               knownProductsChock = removeNotAllowedProducts(["CL_MICROBILLE", "DISINF_PLUS"], diag.input);
               knownProductsLong = removeNotAllowedProducts(["CL_MICROBILLELONG", "CHLORILIQUE_C"], diag.input);
           }
       }
   } else if (diag.input.pool.disinf === "BR") {
       if(diag.input.pool.poolOrSpa === "pool"){
           knownProductsChock = removeNotAllowedProducts(["AQUABROME_REGENERATOR", "CHLORYTE"], diag.input);
           knownProductsLong = removeNotAllowedProducts(["AQUABROME"], diag.input);
       }else{
           knownProductsChock = removeNotAllowedProducts(["CL_MICROBILLE", "DISINF_PLUS"], diag.input);
           knownProductsLong = removeNotAllowedProducts(["BROME_SPATIME", "AQUABROME_MINIPOOL"], diag.input);
       }
   } else if (diag.input.pool.disinf === "O2") {
       if(diag.input.pool.poolOrSpa === "pool"){
           knownProductsChock = removeNotAllowedProducts(["CHLORIKLAR", "CHLORIFIX", "CHLORIFIX_TAB", "CHLORYTE", "BAYROSHOCK", "BAYROXYSHOCK", "BAYROSHOCK_LIGHT"], diag.input);
           knownProductsLong = removeNotAllowedProducts(["S_AND_E_20", "S_AND_E_30", "SOFTSWIM_MULTI", "BAYROSOFT", "BAYROSOFT_LIGHT"], diag.input);

           if(diag.input.pool.regul === "POOL_RELAX" ||
               diag.input.pool.regul === "POOL_MANAGER"){
               if(values.long.indexOf("BAYROSOFT") === -1){
                   //if use regul POOL_RELAX or POOL_MANAGER, force use of BAYROSOFT
                   values.long.push("BAYROSOFT") ;
               }
           }
       }else{
           knownProductsChock = removeNotAllowedProducts(["ACTIVE_OXY_SPATIME","CL_MICROBILLE", "DISINF_PLUS", "BAYROSOFT_LIGHT"], diag.input);
           knownProductsLong = removeNotAllowedProducts(["OXY_SPATIME", "BAYROSOFT_LIGHT"], diag.input);
       }

   }

   

   values.long = removeNotAllowedProducts(values.long, diag.input);
   values.longRegul = removeNotRegulProducts(values.long, diag.input);
   values.shock = removeNotAllowedProducts(values.shock, diag.input);
   if(diag.input.options.mode === "ALG_MUSTARD" && diag.input.pool.disinf === "O2"){
       //ignore selected shock product when ALG MUSTARD and O2
       values.shock = knownProductsChock ;
   }


   function qtyStr(prod, isForRegul) {
       if(VeloxWebView.tr(productTr[prod]) === "n/a"){ return "" ; }//unavailable product
       var qty = productQties[prod];
       if(isForRegul && prod === "CHLORILONG"){
           qty = "" ; //no quantity for CHLORILONG in REGUL case
       }
       if (qty === undefined) {
           qty = "" ;
           //throw "Can't find qty for " + prod;
       }
       
       var str = VeloxWebView.tr(productTr[prod]) ;
       if(str[str.length-1] === ")"){
           str =  "*" +str.substring(0, str.lastIndexOf("("))+"* `" +str.substring(str.lastIndexOf("("))+"`" ;
       }else{
           str = "*" + str + "*";
       }
       
       if(["x18", "x19", "x20"].indexOf(qty) !== -1){
           str = "{{"+qty+"}} "+ str ;   
       }else if (qty) {
           str = VeloxWebView.tr("diag.qtyOf",{qty : "___QTY___", label : str}).replace("___QTY___", "{{"+qty+"}}") ;
       }

       return Mustache.render(str, values);
   }

   function addQty(usedProducts, knownProducts, isForRegul) {
       var prods = usedProducts;
       if (usedProducts.length === 0) {
           prods = knownProducts;
       }
       var result = [];

       prods.forEach(function (p) {
           var str = qtyStr(p, isForRegul) ;
           if(str){
               result.push(str);
           }
       });

       return result;
   }

   function asLabel(prods) {
       var result = [];

       prods.forEach(function (prod) {
           result.push(VeloxWebView.tr(productTr[prod])) ;
       });

       return result;
   }

   //used product label for header
   values.PRODUCTS = asLabel(values.long.concat(values.shock)) ;

   //product with quantities for used in blocks
   if (diag.input.pool.disinf === "CL") {
       values.CL_SHOCK_PRODUCTS = addQty(values.shock, knownProductsChock);
       values.SHOCK_PRODUCTS = values.CL_SHOCK_PRODUCTS;
       values.CL_LONG_PRODUCTS = addQty(values.long, knownProductsLong);
       values.CL_REGUL_LONG_PRODUCTS = addQty(values.longRegul, knownProductsLongRegul, true);
   } else if (diag.input.pool.disinf === "BR") {
       values.BR_SHOCK_PRODUCTS = addQty(values.shock, knownProductsChock);
       values.SHOCK_PRODUCTS = values.BR_SHOCK_PRODUCTS;
   } else if (diag.input.pool.disinf === "O2") {
       values.O2_SHOCK_PRODUCTS = addQty(values.shock, knownProductsChock);
       values.O2_LONG_PRODUCTS = addQty(values.long, knownProductsLong);
       values.SHOCK_PRODUCTS = values.O2_SHOCK_PRODUCTS;
   }

   values.OR_SEP = function () {
       return function (text) {
           if (this[text] === undefined) {
               return text;
           }
           return this[text].join(VeloxWebView.tr("diag.or"));
       };
   };

   values.LIST_SEP = function () {
       return function (text) {
           if (this[text] === undefined) {
               return text;
           }
           var prefix = "" ;
           var postfix = "" ;
           var subClass = ""  ;
           if(this[text].length>1){
               prefix = VeloxWebView.tr("diag.oneProductIn")+'  {.BLOCK_MANY} \n\n' ;
               subClass = ".sub"  ;
               postfix = '<div class="productMany"></div>' ;
           }else{
               subClass = ".productEntry"  ;
           }
           var textArray = this[text] ;
           var returnText =  prefix+textArray.map(function(oneText, i){
                   var imgClass = oneText.substring(oneText.indexOf("*")+1, oneText.lastIndexOf("*")) ;
                   imgClass = "IMG_"+imgClass.toUpperCase().replace(/[^A-Z0-9]/g, "") ;
                   imgClass = "{."+imgClass+subClass+"}\n"  ;
                   return imgClass+oneText+(i===textArray.length-1?postfix:"") ;
               }).join(" \n\n");



           return returnText ;
       };
   };

   values.COMMA_SEP = function () {
       return function (text) {
           if (this[text] === undefined || !Array.isArray(this[text])) {
               return text;
           }
           return this[text].join(", ");
       };
   };
   values.RESPECT = function () {
    return function (text) {
        return '<span class="respect_product">'+(text||"")+'</span>' ;
    };
};




    values.CL_LG_DUREE_M = Mustache.render(blockTemplates.CL_LG_DUREE_M, values);
    values.CL_LG_DUREE_P = Mustache.render(blockTemplates.CL_LG_DUREE_P, values);
    values.CL_LG_DUREE_C = Mustache.render(blockTemplates.CL_LG_DUREE_C, values);

    values.ALG_PRODUCTS = [];
    if (diag.input.pool.equip.length !== 0 || diag.input.pool.alg.length === 0 || diag.input.pool.alg.indexOf("DESALGINE_JET") !== -1) {
        values.ALG_PRODUCTS.push(qtyStr("DESALGINE_JET"));
    }
    if (diag.input.pool.equip.length === 0 && (diag.input.pool.alg.length === 0 || diag.input.pool.alg.indexOf("DESALGINE") !== -1)) {
        values.ALG_PRODUCTS.push(qtyStr("DESALGINE"));
    }

    //used product label for header
    if(Array.isArray(values.equip)){
        values.EQUIPS = asLabel(values.equip) ;
    }else{
        values.EQUIPS = values.equip ;
    }


    values.poolOrSpaLabel = values.poolOrSpa==="pool"?VeloxWebView.tr("customers.pool"):VeloxWebView.tr("customers.spa");
    values.filterLabel = values.filter?VeloxWebView.tr("fields.values.diag.p_filter."+values.filter):" - " ;
    values.regulLabel = " - ";
    if(values.regul && values.regul === "OTHER"){
        values.regulLabel = fieldsValues.regul_other ;
    }else if(values.regul){
        values.regulLabel = VeloxWebView.tr("fields.values.diag.p_regulation."+values.regul) ;
    }

    values.coverLabel = " - ";
    if(values.poolCover && values.poolCover === "OTHER"){
        values.coverLabel = fieldsValues.poolCover_other ;
    }else if(values.poolCover){
        values.coverLabel = VeloxWebView.tr("fields.values.diag.p_pool_cover."+values.poolCover) ;
    }

    values.elecLabel = " - ";
    if(fieldsValues.electrolyzer && fieldsValues.electrolyzer.electrolyzer === "OTHER"){
        values.elecLabel = fieldsValues.electrolyzer_other ;
    }else if(fieldsValues.electrolyzer && fieldsValues.electrolyzer.electrolyzer){
        values.elecLabel = VeloxWebView.tr("fields.values.diag.p_electrolyzer."+fieldsValues.electrolyzer.electrolyzer) ;
    }

    values.disinfLabel = values.disinf?VeloxWebView.tr("fields.values.diag.p_disinfectant."+values.disinfFull):" - " ;
    if(values.saltElect){
        //special case of electrolizer that is seen as CL
        values.disinfLabel =  VeloxWebView.tr("fields.values.diag.p_disinfectant.SALT") ;
    }

    var currentCustomer = customerData ;

    values.customerRef = currentCustomer?(currentCustomer.c_ref_customer||""):"" ;
    values.customerName = currentCustomer?(currentCustomer.c_name||"")+" "+(currentCustomer.c_first_name||""):"" ;
    values.customerAddress = currentCustomer?((currentCustomer.c_address1||"")+ "\n"+(currentCustomer.c_address2||"")):"" ;
    values.customerZipCode = currentCustomer?(currentCustomer.c_zipcode||""):"" ;
    values.customerCity = currentCustomer?(currentCustomer.c_city||""):"" ;

    return values;
};

/**
 * create the condition CSS class for HTML template
 */
function createConditionalClasses(diag, values, plainAddedBlocks, replaces) {

    //compute the conditional classes
    var visible = "{}";
    var hidden = "{display: none !important}";
    var classes = [];

        
    classes.push(".VOL_LESS_5 " + (
        (diag.input.pool.volume < 5 ) ? visible : hidden));
        
    classes.push(".FILTER_GLASS_OR_SAND " + (
        (diag.input.pool.filter === "SAND" || diag.input.pool.filter === "GLASS") ? visible : hidden));

    classes.push(".IS_SPA " + (
        (diag.input.pool.isSpa) ? visible : hidden));
    
    classes.push(".IS_POOL " + (
        (diag.input.pool.isPool) ? visible : hidden));


    classes.push(".FILTER_CART " + (
        (diag.input.pool.filter === "CARTRIDGE" || diag.input.pool.filter === "DIATOM" || diag.input.pool.filter === "POCKET" ) ? visible : hidden));

    classes.push(".NOT_FILTER_GLASS_OR_SAND " + (
        (diag.input.pool.filter !== "SAND" && diag.input.pool.filter !== "GLASS") ? visible : hidden));

    classes.push(".NOT_DIATOM " + (
        (diag.input.pool.filter !== "DIATOM") ? visible : hidden));

    classes.push(".USE_AQUABROME_REG " + (
        (diag.input.pool.shock.indexOf("AQUABROME_REGENERATOR") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));

    classes.push(".USE_CHLORYTE " + (
        (diag.input.pool.shock.indexOf("CHLORYTE") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));

    classes.push(".USE_CHLORIKLAR " + (
        (diag.input.pool.shock.indexOf("CHLORIKLAR") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));

    classes.push(".USE_CHLORIFIX " + (
        (diag.input.pool.shock.indexOf("CHLORIFIX") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));
    
    // classes.push(".USE_CHLORIFIX_TAB " + (
    //     (diag.input.pool.shock.indexOf("CHLORIFIX_TAB") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));
    classes.push(".USE_CHLORIFIX_TAB " + (
        (false) ? visible : hidden));
    
    classes.push(".USE_MICROBILLE " + (
        (diag.input.pool.shock.indexOf("CL_MICROBILLE") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));

    classes.push(".USE_CL_MINIPOOL " + (
        (diag.input.pool.shock.indexOf("CL_MINIPOOL") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));
    
    classes.push(".USE_DESINF " + (
        (diag.input.pool.shock.indexOf("DISINF_PLUS") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));

    classes.push(".NOT_MULTILONG_AND_NOT_VARITAB " + (
        diag.input.pool.long.indexOf("MULTILONG") === -1 && diag.input.pool.long.indexOf("VARITAB") === -1 ? visible : hidden));





    classes.push(".USE_COVER " + (
        (diag.input.pool.poolCover) ? visible : hidden));

    classes.push(".USE_REGUL " + (
        (diag.input.pool.regul) ? visible : hidden));

    classes.push(".USE_ELEC " + (
        (diag.input.pool.saltElect) ? visible : hidden));

    classes.push(".HAS_ELEC " + (
        (diag.input.pool.electrolyzer) ? visible : hidden));

    classes.push(".NO_ELEC " + (
        (!diag.input.pool.electrolyzer) ? visible : hidden));

    classes.push(".NO_REGUL " + (
        (!diag.input.pool.regul) ? visible : hidden));

    classes.push(".NO_REGUL_AND_NO_ELEC " + (
        (!diag.input.pool.regul && !diag.input.pool.saltElect) ? visible : hidden));

    classes.push(".NOT_POOLRELAX_AND_NOT_POOLMANAGER " + (
        (diag.input.pool.regul !== "POOL_RELAX" &&
            diag.input.pool.regul !== "POOL_MANAGER") ? visible : hidden));

    classes.push(".NOT_POOLRELAX_AND_NOT_POOLMANAGER_AND_NO_ELEC " + (
        (diag.input.pool.regul !== "POOL_RELAX" && 
            diag.input.pool.regul !== "POOL_MANAGER" && 
            diag.input.pool.regul !== "AUTOMATIC_CLPH" && 
            diag.input.pool.regul !== "AUTOMATIC_SALT" && 
            diag.input.pool.regul !== "AUTOMATIC_SALT_AS5" && 
            diag.input.pool.regul !== "AUTOMATIC_SALT_AS7" && 
            !diag.input.pool.saltElect) ? visible : hidden));

    classes.push(".USE_POOLRELAX_OR_POOLMANAGER " + (
        (
            diag.input.pool.regul === "POOL_RELAX" || 
            diag.input.pool.regul === "POOL_MANAGER"
        ) ? visible : hidden));
    
    classes.push(".USE_POOL_REGUL " + (
        (
            diag.input.pool.regul === "POOL_RELAX" || 
            diag.input.pool.regul === "POOL_MANAGER" 
        ) ? visible : hidden));

    classes.push(".USE_AUTOMATIC_PH " + (
        (
            diag.input.pool.regul === "AUTOMATIC_CLPH" || 
            diag.input.pool.regul === "AUTOMATIC_PH" 
        ) ? visible : hidden));
    classes.push(".USE_AUTOMATIC_CLPH " + (
        (
            diag.input.pool.regul === "AUTOMATIC_CLPH"
        ) ? visible : hidden));
    classes.push(".USE_AUTOMATIC_SALT " + (
        (
            diag.input.pool.regul === "AUTOMATIC_SALT" ||
            diag.input.pool.regul === "AUTOMATIC_SALT_AS5" ||
            diag.input.pool.regul === "AUTOMATIC_SALT_AS7" 
        ) ? visible : hidden));

        classes.push(".USE_ELEC_NOT_AUTOMATIC_SALT" + (
            (diag.input.pool.saltElect && diag.input.pool.regul !== "AUTOMATIC_SALT" && diag.input.pool.regul !== "AUTOMATIC_SALT_AS5" && diag.input.pool.regul !== "AUTOMATIC_SALT_AS7") ? visible : hidden));


    classes.push(".CL_TOTAL_HIGH " + (
        (diag.variables.computed.clTotalHigh) ? visible : hidden));

    classes.push(".CHLORINE " + (
        (diag.input.pool.disinf === "CL" ? visible : hidden) ));
    
    classes.push(".NOT_CHLORINE " + (
        (diag.input.pool.disinf !== "CL" ? visible : hidden) ));

    classes.push(".CHLORINE_OR_O2 " + (
        ((diag.input.pool.disinf === "CL" ||
            diag.input.pool.disinf === "O2") ? visible : hidden) ));

    classes.push(".CHLORINE_OR_O2_AND_STAB_HI " + (
        ((diag.input.pool.disinf === "CL" ||
            (diag.input.pool.disinf === "O2" && diag.variables.computed.stabHigh)) ? visible : hidden) ));

    classes.push(".BROMINE " + (
        (diag.input.pool.disinf === "BR" ? visible : hidden) ));

    classes.push(".O2 " + (
        (diag.input.pool.disinf === "O2" && diag.input.measures.oxygen ? visible : hidden) ));

    classes.push(".ALK_OK " + (
        (diag.variables.computed.alkOk && diag.input.measures.displayedAlk !== "") ? visible : hidden));

    classes.push(".PH_OK " + (
        (diag.variables.computed.phOk) ? visible : hidden));

    classes.push(".CL_OK " + (
        (diag.variables.computed.clOk) ? visible : hidden));

    classes.push(".CL_TOTAL_OK " + (
        (!diag.variables.computed.clTotalHigh  && diag.input.measures.displayedClTotal !== "") ? visible : hidden));

    classes.push(".BR_OK " + (
        (diag.variables.computed.brOk) ? visible : hidden));

    classes.push(".TH_OK " + (
        (diag.variables.computed.thOk && diag.input.measures.displayedTh !== "") ? visible : hidden));

    classes.push(".SALT_OK " + (
        (!diag.variables.computed.saltLow && diag.input.measures.displayedSalt !== "") ? visible : hidden));

    classes.push(".FE_OK " + (
        (diag.variables.computed.feZero  && diag.input.measures.displayedFe !== "") ? visible : hidden));

    classes.push(".CU_OK " + (
        (diag.variables.computed.cuZero && diag.input.measures.displayedCu !== "") ? visible : hidden));

    classes.push(".STAB_OK " + (
        (!diag.variables.computed.stabHigh && diag.input.measures.displayedStab !== "") ? visible : hidden));


    classes.push(".ALK_NOT_OK " + (
        (!diag.variables.computed.alkOk && diag.input.measures.displayedAlk !== "") ? visible : hidden));

    classes.push(".PH_NOT_OK " + (
        (!diag.variables.computed.phOk) ? visible : hidden));

    classes.push(".CL_NOT_OK " + (
        (!diag.variables.computed.clOk) ? visible : hidden));

    classes.push(".CL_TOTAL_NOT_OK " + (
        (diag.variables.computed.clTotalHigh) ? visible : hidden));

    classes.push(".BR_NOT_OK " + (
        (!diag.variables.computed.brOk) ? visible : hidden));

    classes.push(".TH_NOT_OK " + (
        (!diag.variables.computed.thOk && diag.input.measures.displayedTh !== "") ? visible : hidden));

    classes.push(".ALK_UNDEF " + (
        (diag.input.measures.displayedAlk === "") ? visible : hidden));

    classes.push(".TH_UNDEF " + (
        (diag.input.measures.displayedTh === "") ? visible : hidden));

    classes.push(".STAB_UNDEF " + (
        (diag.input.measures.displayedStab === "") ? visible : hidden));

    classes.push(".FE_UNDEF " + (
        (diag.input.measures.displayedFe === "") ? visible : hidden));

    classes.push(".CU_UNDEF " + (
        (diag.input.measures.displayedCu === "") ? visible : hidden));

    classes.push(".CL_TOTAL_UNDEF " + (
        (diag.input.measures.displayedClTotal === "") ? visible : hidden));

    classes.push(".SALT_UNDEF " + (
        (diag.input.measures.displayedSalt === "" ) ? visible : hidden));

    classes.push(".SALT_NOT_OK " + (
        (diag.variables.computed.saltLow) ? visible : hidden));

    classes.push(".FE_NOT_OK " + (
        (!diag.variables.computed.feZero) ? visible : hidden));

    classes.push(".CU_NOT_OK " + (
        (!diag.variables.computed.cuZero) ? visible : hidden));

    classes.push(".STAB_NOT_OK " + (
        (diag.variables.computed.stabHigh) ? visible : hidden));

    classes.push(".MOD_ALG " + (
        (diag.input.options.mode === "ALG") ? visible : hidden));
    classes.push(".MOD_ALG_MUSTARD " + (
        (diag.input.options.mode === "ALG_MUSTARD") ? visible : hidden));

    classes.push(".MOD_TROU " + (
        (diag.input.options.mode === "TROUBLED") ? visible : hidden));

    classes.push(".MOD_COL " + (
        (diag.input.options.mode === "COLOR") ? visible : hidden));

    classes.push(".MOD_VER " + (
        (diag.input.options.mode === "VER") ? visible : hidden));

    classes.push(".NOT_MOD_VER " + (
        (diag.input.options.mode !== "VER") ? visible : hidden));

    classes.push(".OPT_FILTER " + (
        (diag.input.options.filterMaint) ? visible : hidden));

    classes.push(".OPT_LINE " + (
        (diag.input.options.cleanLine) ? visible : hidden));

    classes.push(".OPT_START " + (
        (diag.input.options.startUp) ? visible : hidden));

    classes.push(".OPT_WINTER " + (
        (diag.input.options.wintering) ? visible : hidden));

    classes.push(".OPT_MARK " + (
        (diag.input.options.mark) ? visible : hidden));
    
    classes.push(".OPT_MARK_SPA " + (
        (diag.input.options.markSpa) ? visible : hidden));
    classes.push(".OPT_MOUSSE " + (
        (diag.input.options.mousse) ? visible : hidden));
    classes.push(".OPT_TROUBLE " + (
        (diag.input.options.troubleWater) ? visible : hidden));
    classes.push(".OPT_GREEN_ALGAE " + (
        (diag.input.options.greenWaterAlgae) ? visible : hidden));
    classes.push(".OPT_GREEN_CRYSTAL " + (
        (diag.input.options.greenWaterCrystal) ? visible : hidden));
    
    var hasPbSpa = diag.input.pool.isSpa && (diag.input.options.markSpa || diag.input.options.mousse
                    || diag.input.options.troubleWater || diag.input.options.greenWaterAlgae
                    || diag.input.options.greenWaterCrystal) ;
    
    classes.push(".NO_PB_SPA " + (
        (!hasPbSpa) ? visible : hidden));
    classes.push(".WITH_PB_SPA " + (
        (hasPbSpa) ? visible : hidden));
    
    
    var hasPbPoolTop= !diag.input.pool.isSpa && (
            diag.input.options.modeTroubled || diag.input.options.modeAlg || diag.input.options.modeAlgMustard || 
            diag.input.options.modeColor) ;
    
    classes.push(".NO_PB_TOP " + (
        (!hasPbSpa && !hasPbPoolTop) ? visible : hidden));
    classes.push(".WITH_PB_TOP " + (
        (hasPbSpa || hasPbPoolTop) ? visible : hidden));
        
    classes.push(".HAS_BLOCK " + (
        (replaces["@BLOCKS_1@" || "@BLOCKS_2@" || "@BLOCKS_3@"
            || "@BLOCKS_4@"|| "@BLOCKS_5@"|| "@BLOCKS_6@"]) ? visible : hidden));
    

    classes.push(".HAS_SALT_DISOLVED " + (
        (diag.input.measures.displayedSaltDisolved !== "") ? visible : hidden));

    classes.push(".HAS_PHOSPHATE " + (
        (diag.input.measures.displayedPhos !== "") ? visible : hidden));

    classes.push(".PHOSPHATE_OK " + (
            (diag.variables.computed.phosOk) ? visible : hidden));

    classes.push(".PHOSPHATE_NOT_OK " + (
            (!diag.variables.computed.phosOk) ? visible : hidden));



    classes.push(".HAS_RECO " + (
        (diag.input.options.startUp || diag.input.options.wintering ||
        diag.input.options.filterMaint || diag.input.options.cleanLine || diag.input.options.mark) ? visible : hidden));

    classes.push(".HAS_USER " + (
            (values.diagUser) ? visible : hidden));

    classes.push(".FILTER_GLASS_OR_SAND_AND_NOT_MOD_ALG_AND_NOT_MOD_TROU " + (
        (["GLASS", "SAND"].indexOf(diag.input.pool.filter) !== -1 &&
            diag.input.options.mode !== "ALG" && diag.input.options.mode !== "ALG_MUSTARD" &&diag.input.options.mode !== "TROUBLED") ? visible : hidden));

    classes.push(".NOT_FILTER_GLASS_OR_SAND_OR_MOD_ALG_OR_MOD_TROU " + (
        (["GLASS", "SAND"].indexOf(diag.input.pool.filter) === -1 ||
            diag.input.options.mode === "ALG" || diag.input.options.mode === "ALG_MUSTARD" || diag.input.options.mode === "TROUBLED") ? visible : hidden));

    var shockIsOnlyChloryte = (diag.input.pool.shock.length === 1 && diag.input.pool.shock[0] === "CHLORYTE");
    // var shockIsOnlyBayroshock = (diag.input.pool.shock.length === 1 && (diag.input.pool.shock[0] === "BAYROSHOCK" || diag.input.pool.shock[0] === "BAYROXYSHOCK"));
    // var shockIsOnlyBayrolLight = (values.long.length === 1 && values.long[0] === "BAYROSOFT_LIGHT");
    // var longIsSE20Only = (diag.input.pool.long.length === 1 && diag.input.pool.long[0] === "S_AND_E_20");
    // var longIsSE30Only = (diag.input.pool.long.length === 1 && diag.input.pool.long[0] === "S_AND_E_30");
    // var longIsSE20AndSE30Only = (diag.input.pool.long.length === 2 && diag.input.pool.long.indexOf("S_AND_E_30")!==-1
    //                         &&  diag.input.pool.long.indexOf("S_AND_E_20")!==-1);
    
    var noLongProducts = diag.input.pool.long.length === 0 ;
    var longHasBayrolight = diag.input.pool.long.some(function(l){ return l === "BAYROSOFT_LIGHT";});
    var longHasSoftswim = diag.input.pool.long.some(function(l){ return l === "SOFTSWIM_MULTI";});


    // var isOnlyBayroshockOrIsOnlySE20SE30 = shockIsOnlyBayrolLight ||  shockIsOnlyBayroshock || longIsSE20Only || longIsSE30Only || longIsSE20AndSE30Only ;
    var isBayroshofOrSoftswim = noLongProducts ||  longHasBayrolight || longHasSoftswim ;

    classes.push(".NOTONLY_CHLORYTE " + (
            (!shockIsOnlyChloryte) ? visible : hidden));

    // classes.push(".NOT_BAYROSHOCK_AND_NOT_SE20_AND_NOT_SE30 " + (
    //     !isOnlyBayroshockOrIsOnlySE20SE30 ? visible : hidden));

    classes.push(".LONG_BAYROSOFT_OR_SOFTSWIM " + (
            isBayroshofOrSoftswim ? visible : hidden));

    classes.push(".USE_BAYROSHOCK " + (
        (diag.input.pool.shock.indexOf("BAYROSHOCK") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));
        
    classes.push(".USE_BAYROXYSHOCK " + (
        (diag.input.pool.shock.indexOf("BAYROXYSHOCK") !== -1 || diag.input.pool.shock.length === 0) ? visible : hidden));

    classes.push(".PH_VERY_LOW " + (
        (diag.variables.computed.phVeryLow) ? visible : hidden));

    classes.push(".PH_VERY_HIGH " + (
        (diag.variables.computed.phVeryHigh) ? visible : hidden));

    classes.push(".ALK_VERY_LOW " + (
        (diag.variables.computed.alkVeryLow) ? visible : hidden));

    classes.push(".MOD_TROU_AND_CU_OR_FE " + (
        (diag.input.options.mode === "TROUBLED" &&
            (!diag.variables.computed.feZero || !diag.variables.computed.cuZero)) ? visible : hidden));

    classes.push(".MOD_ALG_AND_CU_OR_FE " + (
        ((diag.input.options.mode === "ALG" || diag.input.options.mode === "ALG_MUSTARD") && (!diag.variables.computed.feZero || !diag.variables.computed.cuZero)) ? visible : hidden));

    classes.push(".MOD_COL_AND_OTHER_BLOCK " + (
        (diag.input.options.mode === "COLOR" &&
            (diag.blockList.indexOf("STA_1") !== -1 ||
                diag.blockList.indexOf("PH_2") !== -1 ||
                diag.blockList.indexOf("CL_4") !== -1 ||
                diag.blockList.indexOf("SEL_1") !== -1 ||
                diag.blockList.indexOf("TH_1") !== -1 ||
                diag.blockList.indexOf("TH_2") !== -1 ||
                diag.blockList.indexOf("TH_3") !== -1
                )) ? visible : hidden));



    //Display stab if not null for CL. For O2, display only if high
    classes.push(".STAB_NOT_NULL " + (
        (
            (diag.input.measures.stab
            && diag.input.pool.disinf === "CL")
            ||
            (diag.variables.computed.stabHigh
            && diag.input.pool.disinf === "O2")
            ) ? visible : hidden));

    classes.push(".HAS_NOTE " + (
        (diag.input.globalNotes !== null && diag.input.globalNotes !=="" ) ? visible : hidden));

    classes.push(".USE_EQUIP " + (
        (diag.input.pool.equip && diag.input.pool.equip.length > 0 ) ? visible : hidden));
    
    classes.push(".NO_X30_QTY " + (
        (diag.variables.computed.noX30Qty) ? visible : hidden));
    
    classes.push(".HAS_X30_QTY " + (
        (!diag.variables.computed.noX30Qty) ? visible : hidden));


    var classesShopping = {
        HAS_CL_SHOCK : false,
        HAS_CL_LONG : false,
        HAS_BR_SHOCK : false,
        HAS_BR_LONG : false,
        HAS_ALG : false,
        HAS_O2_SHOCK : false,
        HAS_O2_LONG : false,
        HAS_ALCAPLUS : false,
        HAS_CALCINEX : false,
        HAS_FILTERCLEAN : false,
        HAS_PHMINUS : false,
        HAS_PHPLUS : false,
        HAS_DECALCIT : false,
        HAS_SUPERFLOCK : false,
        HAS_SUPERKLAR : false,
        HAS_NOPHOS : false,
        HAS_AQUABROME : false,
        HAS_DISINF_PLUS_SPATIME : false,
        HAS_BROME_SPATIME : false,
        HAS_AQUABROME_MINIPOOL : false
    } ;

    plainAddedBlocks.forEach(function(blockSource){
        if(blockSource.indexOf("CL_SHOCK_PRODUCTS") !== -1){ classesShopping.HAS_CL_SHOCK = true ; }
        if(blockSource.indexOf("CL_LONG_PRODUCTS") !== -1){ classesShopping.HAS_CL_LONG = true ; }
        if(blockSource.indexOf("{{CL_LG_DUREE_") !== -1){ classesShopping.HAS_CL_LONG = true ; }
        if(blockSource.indexOf("ALG_PRODUCTS") !== -1){ classesShopping.HAS_ALG = true ; }
        if(blockSource.indexOf("BR_SHOCK_PRODUCTS") !== -1){ classesShopping.HAS_BR_SHOCK = true ; }
        if(blockSource.indexOf("O2_SHOCK_PRODUCTS") !== -1){ classesShopping.HAS_O2_SHOCK = true ; }
        if(blockSource.indexOf("O2_LONG_PRODUCTS") !== -1){ classesShopping.HAS_O2_LONG = true ; }
        if(blockSource.indexOf("{{xtac}}") !== -1){ classesShopping.HAS_ALCAPLUS = true ; }
        if(blockSource.indexOf("{{x1}}") !== -1){ classesShopping.HAS_CALCINEX = true ; }
        if(blockSource.indexOf("{{x9}}") !== -1){ classesShopping.HAS_DECALCIT = true ; }
        if(blockSource.indexOf("{{x17}}") !== -1){ classesShopping.HAS_FILTERCLEAN = true ; }
        if(blockSource.indexOf("{{xph-}}") !== -1){ classesShopping.HAS_PHMINUS = true ; }
        if(blockSource.indexOf("{{xph+}}") !== -1){ classesShopping.HAS_PHPLUS = true ; }
        if(blockSource.indexOf("{{x5}}") !== -1){ classesShopping.HAS_SUPERFLOCK = true ;}
        if(blockSource.indexOf("{{x16}}") !== -1){ classesShopping.HAS_SUPERKLAR = true ;}
        if(blockSource.indexOf("{{x25}}") !== -1){ classesShopping.HAS_NOPHOS = true ;}
        if(blockSource.indexOf("{{x29}}") !== -1){ classesShopping.HAS_DISINF_PLUS_SPATIME = true ;}
        if(blockSource.indexOf("{{x30}}") !== -1){ classesShopping.HAS_BROME_SPATIME = true ;}
        if(blockSource.indexOf("{{x30}}") !== -1){ classesShopping.HAS_AQUABROME_MINIPOOL = true ;}
        if(blockSource.indexOf("*Aquabrome*") !== -1){ classesShopping.HAS_AQUABROME = true ;}
    }) ;

    Object.keys(classesShopping).forEach(function(k){
        classes.push("."+k+" " + (
                (classesShopping[k]) ? visible : hidden));
    }) ;

    diag.results.forEach(function (res) {
        var block = res.block;
        classes.push("."+block+", ."+block+" p {display : block !important} ");
    });

    return classes.join("\n\n");
};

/**
 * User clicked on the diag start button
 * @param {*} ev 
 */
diagController.formController.onDiagStart = function(){
    VeloxWebView.longTask(function(done){
        this.view.checkForm(function(err, checkOk){
            if(err){ 
                // back to top if error
                if(document.querySelector('.main-views-wrapper')){
                    document.querySelector('.main-views-wrapper').scrollTop = 0;
                }
                return done(err);   
            }
            if(!checkOk){
                if(document.querySelector('.main-views-wrapper')){
                    document.querySelector('.main-views-wrapper').scrollTop = 0;
                }
                return done(null, false) ;
            }
            this.view.updateData() ;


            if(this.data.customer){
                var diag = this.data;
                diag.c_id = diag.customer.c_id;
                if(!diag.d_id){
                    diag.d_id = uuid.v4() ;
                }
            
                var records = [
                    {table: "diag", record: diag} 
                ] ;

                if(this.data.customer.c_id_extrabat){
                    records.push( { 
                        table: "extrabat_diag",
                        record: {
                            e_code: diag.d_id,
                            d_id: diag.d_id,
                            r_code: this.data.customer.r_code,
                            e_id: this.data.customer.c_id_extrabat,
                            e_status: "todo"
                        }
                    });
                }
            
                this.api.api.transactionalChanges(records, function(err){
                    if(err){return done(err) ;}
                    
                    if(this.data.customer.c_id_extrabat){
                        diagController.formController.createReportHTML(diag,"VIEW",function(err, diagHtml){
                            this.api.saveBinary(new Blob([diagHtml.reportHTML], {type: 'text/html'}),
                                {
                                    table_name: "extrabat_diag", 
                                    table_uid: diag.d_id, 
                                    mime_type: "text/html",
                                    description : "report",
                                    filename: "report.html"
                            }, function(err){
                                if(err){return done(err) ;}

                                diagController.formController.openReport(this.data, this.data.customer ?'WITH_CUSTOMER':'NO_CUSTOMER', done) ;
                            }.bind(this)) ;
                        }.bind(this)) ;
                    }else{
                        diagController.formController.openReport(this.data, this.data.customer ?'WITH_CUSTOMER':'NO_CUSTOMER', done) ;
                    }
                }.bind(this)) ;
            }else{
                diagController.formController.openReport(this.data, this.data.customer ?'WITH_CUSTOMER':'NO_CUSTOMER', done) ;
            }

        }.bind(this)) ;
    }.bind(this)) ;
} ;


diagController.formController.getLogo = function(reseller_settings, callback){
    if(reseller_settings && reseller_settings.binary){
        this.api.readBinary.urlBase64(reseller_settings.binary, function(err, url){
            if(err){ return callback(err) ;}
            callback(null, url) ;
        }) ;
    }else{
        callback(null, "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8zwQAAgYBAyKDV6YAAAAASUVORK5CYII=") ;
    }
} ;

diagController.formController.createReportHTML = function(diagData, mode, done){
    if(!done) { done = function(){} ;}
    this.api.api.multiread({ 
        reseller_settings : {
            searchFirst: {},
            joinFetch: [{otherTable: "velox_binary", type: "2one", thisField: "r_code", otherField:"table_uid", name: "binary"}]
        }
    }, function(err, reads){
        if(err){ return done(err) ;}
        
        this.getLogo(reads.reseller_settings, function(err, logoUrl){
            if(err){ return done(err) ;}
            var settingsOptions = reads.reseller_settings||{} ;

            this.currentDiag = diagData;

            var inputData = getInputData(this.currentDiag) ;

            var t = VeloxWebView.tr ;
            var diag = new Diag(inputData, t);
            diag.doFullDiag();

            
            veloxScriptLoader.load([
                {name: "block-template-"+VeloxWebView.i18n.getLang(),
                    type: "json",
                    version: "1.0.0",
                    localPath: "templates/diag_blocks_"+VeloxWebView.i18n.getLang()+".json",
                }
            ], function(err, results){
                if(err){ return done(err) ;}
                var blockTemplates = results[0][0] ;

                var values = aggregateValues(diag, this.currentDiag, diagData.customer, blockTemplates);
            
                values.tr = trTemplate[VeloxWebView.i18n.getLang()].reportTemplate ;


                veloxScriptLoader.load([
                    {name: "template-"+VeloxWebView.i18n.getLang(),
                        type: "plain",
                        version: "1.0.0",
                        localPath: "templates/html/template_"+VeloxWebView.i18n.getLang()+".html",
                    }
                ], function(err, results){
                    if(err){ return done(err) ;}
                    var templateHTML = results[0][0] ;

                    var reportHTML = templateHTML;

                    //will contain the HTML to replace in report HTML
                    var replaces = {
                        "@SHOP_LOGO@"   : logoUrl,
                        "@SHOP_NAME@"   : settingsOptions.rs_shop_name||"",
                        "@SHOP_TEXT@"   : settingsOptions.rs_textbox||"",
                        "@BLOCKS_0@"    : "",
                        "@BLOCKS_1@"    : "",
                        "@BLOCKS_2@"    : "",
                        "@BLOCKS_3@"    : "",
                        "@BLOCKS_4@"    : "",
                        "@BLOCKS_5@"    : "",
                        "@BLOCKS_6@"    : "",
                        "@BLOCKS_7@"    : "",
                        "@BLOCKS_8@"    : "",
                        "@BLOCKS_9a@"   : "",
                        "@BLOCKS_9b@"   : "",
                        "@BLOCKS_9c@"   : "",
                        "@GLOBAL_NOTES@": diag.input.globalNotes?diag.input.globalNotes.replace(/\n/g, "<br/>"):""
                    };

                    var products = {
                        "CL_SHOCK_PRODUCTS": { many: true, key : "CL_SHOCK_PRODUCTS"},
                        "CL_LONG_PRODUCTS" : [
                                                { many: true, key : "CL_LONG_PRODUCTS", css: "NOT_POOLRELAX_AND_NOT_POOLMANAGER_AND_NO_ELEC"},
                                                { many: true, key : "CL_REGUL_LONG_PRODUCTS", css: "USE_POOLRELAX_OR_POOLMANAGER"},
                                            ],
                        "{{CL_LG_DUREE_"   : [
                                                { many: true, key : "CL_LONG_PRODUCTS", css: "NOT_POOLRELAX_AND_NOT_POOLMANAGER_AND_NO_ELEC"},
                                                { many: true, key : "CL_REGUL_LONG_PRODUCTS", css: "USE_POOLRELAX_OR_POOLMANAGER"},
                                            ],
                        "ALG_PRODUCTS"     : { many: true, key : "ALG_PRODUCTS"},
                        "BR_SHOCK_PRODUCTS": { many: true, key : "BR_SHOCK_PRODUCTS"},
                        "O2_SHOCK_PRODUCTS": { many: true, key : "O2_SHOCK_PRODUCTS"},
                        "O2_LONG_PRODUCTS" : { many: true, key : "O2_LONG_PRODUCTS"}, 
                        "{{xtac}}"         : { img : "IMG_ALCAPLUS", label :  t("fields.values.pool.p_alkalinity.ALCA_PLUS"), qty : "{{xtac}}"},
                        "{{x1}}"           : { img : "IMG_CALCINEX", label :  t("fields.values.pool.p_hardness.CALCINEX"), qty : "{{x1}}"},
                        "{{x9}}"           : [{ img : "IMG_DECALCITFILTRE", css:"FILTER_GLASS_OR_SAND", label :  t("fields.values.pool.p_filter_maintenance.DECALCIT_FILTER"), qty : "{{x9}}"},
                                            { img : "IMG_DECALCITFILTRE", css:"NOT_FILTER_GLASS_OR_SAND", label :  t("fields.values.pool.p_filter_maintenance.DECALCIT_FILTER"), qty : "{{x9}}"}],
                        "{{x17}}"          : { img : "IMG_FILTERCLEANTAB", css: "NOT_MULTILONG_AND_NOT_VARITAB",  label :  t("fields.values.pool.p_filter_maintenance.FILTERCLEAN_TAB"), qty : "{{x17}}"},
                        "{{xph-}}"         : { img : "IMG_PHMINUS", label :  t("fields.values.pool.p_ph_correction.PH_MINUS"), qty : "{{xph-}}"},  
                        "{{xph+}}"         : { img : "IMG_PHPLUS", label :  t("fields.values.pool.p_ph_correction.PH_PLUS"), qty : "{{xph+}}"},  
                        "{{xphspa-}}"         : { img : "IMG_PHMOINSSPATIME", label :  t("fields.values.spa.s_water_balance.PH_MINUS_SPATIME"), qty : "{{xphspa-}}"},  
                        "{{xphspa+}}"         : { img : "IMG_PHPLUSSPATIME", label :  t("fields.values.spa.s_water_balance.PH_PLUS_SPATIME"), qty : "{{xphspa+}}"},  
                        "{{xphmini-}}"         : { img : "", label :  t("fields.values.spa.s_water_balance.PH_MINUS_MINIPOOL"), qty : "{{xphmini-}}"},  
                        "{{xphmini+}}"         : { img : "", label :  t("fields.values.spa.s_water_balance.PH_PLUS_MINIPOOL"), qty : "{{xphmini+}}"},  
                        "{{x5}}"           : { img : "IMG_SUPERFLOCKPLUS", css: "FILTER_GLASS_OR_SAND", label :  t("fields.values.pool.p_flocculation.SUPERFLOCK_PLUS"), qty : "{{x5}}"},  
                        "{{x16}}"          : { img : "IMG_SUPERKLAR", label :  t("fields.values.pool.p_flocculation.SUPERKLAR"), qty : "{{x16}}"},   
                        "{{x25}}"          : { img : "IMG_NOPHOS", label :  t("fields.values.pool.p_advanced_other.NOPHOS"), qty : "{{x25}}"},   
                        "{{x26}}"          : { img : "IMG_ANTICALCAIRESPATIME", label :  t("fields.values.spa.s_water_balance.ANTI_CALC"), qty : "{{x26}}"},   
                        "{{x26mini}}"      : { img : "IMG_ANTICALCAIREMINI", label :  t("fields.values.spa.s_water_balance.ANTI_CALC"), qty : "{{x26mini}}"},   
                        "{{x27}}"          : { img : "", label :  t("fields.values.spa.s_disinf_long.CL_MICROBILLELONG"), qty : "{{x27}}"},   
                        "{{x27mini}}"          : { img : "", label :  t("fields.values.spa.s_disinf_long.CL_MINIPOOLLONG"), qty : "{{x27mini}}"},   
                        "{{x28}}"          : { img : "", label :  t("fields.values.spa.s_disinf_shock.CL_MICROBILLE"), qty : "{{x28}}"},   
                        "{{x28mini}}"      : { img : "", label :  t("fields.values.spa.s_disinf_shock.CL_MINIPOOL"), qty : "{{x28mini}}"},   
                        "{{x28minialgae}}"      : { img : "", label :  t("fields.values.spa.s_disinf_shock.CL_MINIPOOL"), qty : "{{x28minialgae}}"},   
                        "{{x29}}"          : { img : "IMG_DISINFPLUSSPATIME", label :  t("fields.values.spa.s_disinf_shock.DISINF_PLUS"), qty : "{{x29}}"},   
                        "{{x30}}"          : { img : "IMG_BROMESPATIME", label :  t("fields.values.spa.s_disinf_long.BROME_SPATIME"), qty : "{{x30}}"},    
                        "{{x29mini}}"          : { img : "IMG_DISINFPLUSMINI", label :  t("fields.values.spa.s_disinf_shock.DISINF_PLUS"), qty : "{{x29mini}}"},   
                        "{{x30mini}}"          : { img : "", label :  t("fields.values.spa.s_disinf_long.AQUABROME_MINIPOOL"), qty : "{{x30mini}}"},    
                        "{{x33}}"          : { img : "", label :  t("fields.values.spa.s_other_product.ANTI_MOUSSE"), qty : "{{x33}}"},    
                        "{{x33mini}}"          : { img : "", label :  t("fields.values.spa.s_other_product.ANTI_MOUSSE_MINIPOOL"), qty : "{{x33mini}}"},    
                        "{{x35}}"          : { img : "IMG_NETTOYANTCANALISATIONSSPATIME", label :  t("fields.values.spa.s_other_product.NETT_CANAL"), qty : "{{x35}}"},    
                        "{{x39}}"          : { img : "IMG_DESALGINEMUSTARD", label :  t("fields.values.pool.p_algae.DESALGINE_MUSTARD"), qty : "{{x39}}"},    
                        "{{x40}}"          : { img : "IMG_POOL_DETOX", label :  t("fields.values.pool.p_respect.POOL_DETOX"), qty : "{{x40}}"},    
                        "{{x41}}"          : { img : "IMG_NO_POLLEN", label :  t("fields.values.pool.p_respect.NO_POLLEN"), qty : "{{x41}}"},    
                    } ;
                    products["*"+t("fields.values.pool.p_disinf_long.AQUABROME")+"*"] =  { img : "IMG_AQUABROME", label :  t("fields.values.pool.p_disinf_long.AQUABROME")} ;
                    products[t("fields.values.spa.s_other_product.NETT_FIL")] =  { img : "IMG_NETTOYANTFILTRESPATIME", label :  t("fields.values.spa.s_other_product.NETT_FIL"), css: "FILTER_CART"};
                    products[t("fields.values.spa.s_other_product.NETT_LINE")] = { img : "IMG_NETTOYANTLIGNEDEAUSPATIME", label :  t("fields.values.spa.s_other_product.NETT_LINE")};
                    //products[t("fields.otherProductsSpaList.ANTI_MOUSSE")] = { img : "IMG_ANTIMOUSSESPATIME", label :  t("fields.otherProductsSpaList.ANTI_MOUSSE")};
                    products[t("fields.values.pool.p_cleaning.DECALCIT_SUPER")] =  { img : "IMG_DECALCITSUPER", label :  t("fields.values.pool.p_cleaning.DECALCIT_SUPER")};
                    products[t("fields.values.pool.p_cleaning.DECALCIT_FILTRE")] =  { img : "DECALCIT_FILTRE", label :  t("fields.values.pool.p_cleaning.DECALCIT_FILTRE")};
                    products["*"+t("fields.values.pool.p_cleaning.BORDNET")+"*"] =  { img : "", label :  t("fields.values.pool.p_cleaning.BORDNET")};
                    products[t("fields.values.pool.p_disinf_shock.CHLORYTE")] =  { img : "IMG_CHLORYTE", label :  t("fields.values.pool.p_disinf_shock.CHLORYTE"), dontDisplayIfShock : true};
                    products[t("fields.values.pool.p_disinf_long.CHLORYTE_STICKS")] =  { img : "IMG_CHLORYTE_STICKS", label :  t("fields.values.pool.p_disinf_long.CHLORYTE_STICKS")};
                    products[t("fields.values.pool.p_respect.NO_CHLOR")] =  { img : "IMG_NO_CHLOR", label :  t("fields.values.pool.p_respect.NO_CHLOR")};
                    products[t("fields.values.pool.p_respect.NO_CALC")] =  { img : "IMG_NO_CHLOR", label :  t("fields.values.pool.p_respect.NO_CALC")};
                    products[t("fields.values.pool.p_respect.NO_GREASE")] =  { img : "IMG_NO_CHLOR", label :  t("fields.values.pool.p_respect.NO_GREASE")};

                    var plainBlocksAdded = [] ;

                    diag.results.forEach(function (res) {
                        var block = res.block;
                        var order = res.order;
                        var pos = order.substring(0, order.indexOf("."));
                        if (blockTemplates[block] === undefined) {
                            console.log("BLOCK " + block + " not found in templates");
                        } else {
                            
                            var productsList = {} ;
                            
                            var hasShockProducts = false;
                            if(pos !== "9b"){
                                plainBlocksAdded.push(blockTemplates[block]) ;
                                
                                Object.keys(products).forEach(function(p){
                                    var index = blockTemplates[block].indexOf(p) ;
                                    if(index !== -1){
                                        productsList[index] = products[p] ;
                                        if(products[p].key && products[p].key.indexOf("_SHOCK_") !== -1){
                                            hasShockProducts = true;
                                        } 
                                    }
                                }) ;
                            }
                            
                            console.log("BLOCK PRODUCTS", productsList) ;
                            
                            var productHTML = "";
                            Object.keys(productsList).sort().forEach(function(index){
                                var p = productsList[index] ;
                                if(hasShockProducts && p.dontDisplayIfShock){ return; }
                                if(!Array.isArray(p)){
                                    p = [p] ;
                                }
                                p.forEach(function(product){
                                    if(product.many){
                                        var productsManyImg = [] ;
                                        var productsManyText = [] ;
                                        values[product.key].forEach(function(oneText){
                                            var imgClass = oneText.substring(oneText.indexOf("*")+1, oneText.lastIndexOf("*")) ;
                                            imgClass = "IMG_"+imgClass.toUpperCase().replace(/[^A-Z0-9]/g, "") ;
                                            productsManyImg.push(imgClass) ;
                                            productsManyText.push(oneText) ;
                                        }) ;
                                        if(productsManyImg.length > 1){
                                            // var height = 75+((productsManyImg.length-1)*20) ;
                                            productHTML += '<div class="MANY '+(product.css || '')+'"><div class="text">';
                                            productsManyText.forEach(function(txt){
                                                var name = txt.substring(txt.indexOf("*")+1, txt.lastIndexOf("*")) ;
                                                var indexStart = txt.indexOf("*");
                                                // if(indexStart > 4){
                                                //     indexStart = indexStart-3 ;
                                                // }
                                                var qty = txt.substring(0, txt.lastIndexOf(" ", indexStart)).trim() ;
                                                if(/\s\w*\s\w*$/.test(qty)){
                                                    qty = qty.substring(0, qty.lastIndexOf(" ")) ;
                                                }
                                                productHTML += '<span class="name check">'+name+'</span>'+
                                                    ' <span class="quantity">'+qty+'</span>'+
                                                    '<br>' ;
                                            }) ;
                                            productHTML += '</div>' ;
                                            productsManyImg.forEach(function(img){
                                                productHTML += '<div class="'+img+' sub"></div>' ;
                                            }) ;
                                            productHTML += '</div>' ;
                                        }else if(productsManyImg.length === 1){
                                            var txt = productsManyText[0];
                                            var name = txt.substring(txt.indexOf("*")+1, txt.lastIndexOf("*")) ;
                                            var indexStart = txt.indexOf("*");
                                            // if(indexStart > 4){
                                            //     indexStart = indexStart-3 ;
                                            // }
                                            var qty = txt.substring(0, txt.lastIndexOf(" ", indexStart)).trim() ;
                                            if(/\s\w*\s\w*$/.test(qty)){
                                                qty = qty.substring(0, qty.lastIndexOf(" ")) ;
                                            }

                                            productHTML +=  '<div class="'+(product.css||'')+' '+productsManyImg[0]+' productEntry">'+
                                            '<div style="padding-top: 15px;overflow: hidden;">'+
                                            '<span class="name">'+name+'</span>' +
                                            ' <span class="quantity">'+(qty||"&nbsp;")+'</span> </div>'+
                                            '</div>' ;
                                        }
                                    }else{
                                        var qty = "";
                                        if(product.qty){
                                            qty = Mustache.render(product.qty, values);
                                        }
                                        productHTML +=  '<div class="'+(product.css||'')+' '+product.img+' productEntry">'+
                                            '<div style="padding-top: 15px;overflow: hidden;">'+
                                            '<span class="name">'+product.label+'</span>' +
                                            ' <span class="quantity">'+(qty||"&nbsp;")+'</span> </div>'+
                                            '</div>' ;
                                    }
                                }.bind(this)) ;
                            }.bind(this)) ;
                            if(productHTML){
                                productHTML = '<div class="product">'+productHTML+"</div>" ;
                            }

                            var rendered2 = Mustache.render(blockTemplates[block], values);
                            //console.log(rendered2) ;
                            var blockHTML = rho.toHtml(rendered2);


                            var staCouncil = this.currentDiag.d_sta_council ;
                            if(staCouncil && (block === "STA_1" || block === "STA_2")){
                                //saved sta_x council, replace the link by the saved text
                                var linkIndexStart = blockHTML.indexOf("<a") ;
                                var linkIndexEnd = blockHTML.indexOf("</a", linkIndexStart) ;
                                while(linkIndexStart!==-1){
                                    blockHTML = blockHTML.substring(0, linkIndexStart)+staCouncil+blockHTML.substring(linkIndexEnd+4) ;
                                    linkIndexStart = blockHTML.indexOf("<a") ;
                                    linkIndexEnd = blockHTML.indexOf("</a", linkIndexStart) ;
                                }
                            }
                            
                            var temp2Council = this.currentDiag.d_temp_council ;
                            if(temp2Council && (block === "TEMP_2")){
                                //saved sta_x council, replace the link by the saved text
                                var linkIndexStart = blockHTML.indexOf("<a") ;
                                var linkIndexEnd = blockHTML.indexOf("</a", linkIndexStart) ;
                                while(linkIndexStart!==-1){
                                    blockHTML = blockHTML.substring(0, linkIndexStart)+temp2Council+blockHTML.substring(linkIndexEnd+4) ;
                                    linkIndexStart = blockHTML.indexOf("<a") ;
                                    linkIndexEnd = blockHTML.indexOf("</a", linkIndexStart) ;
                                }
                            }
                            
                            var classBlock ="block";
                            if(pos.indexOf("9c") === 0){
                                classBlock += " bigBlock recoBlock";
                            }
                            
                            blockHTML = "\n<div class=\""+classBlock+"\" id=\""+block+"\">\n<div class=\"textcontent\">" + blockHTML + "\n</div>"+productHTML+"</div>";

                            replaces["@BLOCKS_" + pos + "@"] += blockHTML;
                        }



                    }.bind(this)) ;

                    var classes = createConditionalClasses(diag, values, plainBlocksAdded, replaces);
                    replaces["@CLASSES@"] = classes ;
                    
                    replaces["@SHOPPING_LIST@"] = rho.toHtml(Mustache.render(blockTemplates["SHOPPING_LIST"], values)) ;

                    var customProductsHTML = [] ;
                    var customProducts = [] ;
                    if(this.currentDiag.customProducts && this.currentDiag.customProducts.length > 0){
                        customProducts = this.currentDiag.customProducts ;
                    }
                    if(customProducts){
                        //saved custom products, add them to the HTML
                        customProducts.forEach(function(product){
                            var p = product.dcp_product_name ;
                            var className = "IMG_"+p.toUpperCase().replace(/[^A-Z0-9]/g, "") ;
                            var isOther=reportHTML.indexOf('<option value="'+p) === -1 ;
                            if(isOther){
                                className = "IMG_OTHER" ;
                            }
                            customProductsHTML.push('<div class="productEntry '+className+'"><button class="removeProduct no-print">X</button><div>'+p+'</div></div>') ;
                        }) ;

                    }

                    replaces["@SHOPPING_CUSTOMS@"] = customProductsHTML.join("") ;

                    if(diagData.readOnly) {
                        replaces['<table id="wrap_contents">'] = '<table id="wrap_contents" class="readonly">' ;
                    }

                    reportHTML = Mustache.render(reportHTML, values);

                    Object.keys(replaces).forEach(function (b) {
                        reportHTML = reportHTML.replace(b, replaces[b]);
                    });



                    done(null, {diag : diagData, reportHTML: reportHTML, mode: mode}) ;
                    //console.log("REPORT !!!!!! ", reportHTML) ;
                    // _self.viewReportViewer.setReadOnly(_self.isReadOnly) ;
                    // _self.viewReportViewer.load(reportHTML, _self.currentCustomer, _self.currentDiag);
                    // _self.viewReportViewer.show();
                    // _self.viewDiagOnly.hide();
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

diagController.formController.openReport = function(diagData, mode, callback){
    if(!callback) { callback = function(){} ;}
    VeloxWebView.longTask(function(done){
        this.createReportHTML(diagData, mode, function(err, report){
            if(err){ return done(err) ;}
            this.navigate("report", report, "anonymous") ;
            done() ;
        }.bind(this)) ;
    }.bind(this), callback) ;
} ;


diagController.formController.updateMeasureFromSpin = function(measures){
    this.view.updateData() ;

    this.data.d_br = measures.bromine ;
    this.data.d_free_cl = measures.freeCl ;
    this.data.d_total_cl = measures.totalCl ;
    this.data.d_alk = measures.alk ;
    this.data.d_ph = measures.ph ;
    this.data.d_br = measures.bromine ;
    this.data.d_hardness = measures.hardness ;
    this.data.d_cu = measures.cu ;
    this.data.d_fe = measures.fe ;
    this.data.d_stab = measures.stab ;
    this.data.d_phosphate = measures.phosphate ;
    this.data.d_salt_disolved = measures.salt ;
    if(measures.signs){
        this.data.d_ph_sign        = measures.signs.ph;
        this.data.d_hardness_sign  = measures.signs.hardness;
        this.data.d_free_cl_sign   = measures.signs.freeCl;
        this.data.d_total_cl_sign  = measures.signs.totalCl;
        this.data.d_br_sign        = measures.signs.bromine;
        this.data.d_salt_sign      = measures.signs.salt;
        this.data.d_cu_sign        = measures.signs.cu;
        this.data.d_fe_sign        = measures.signs.fe;
        this.data.d_stab_sign      = measures.signs.stab;
        this.data.d_phosphate_sign = measures.signs.phosphate;
    }else{
        this.data.d_ph_sign        = null;
        this.data.d_hardness_sign  = null;
        this.data.d_free_cl_sign   = null;
        this.data.d_total_cl_sign  = null;
        this.data.d_br_sign        = null;
        this.data.d_salt_sign      = null;
        this.data.d_oxygen_sign    = null;
        this.data.d_cu_sign        = null;
        this.data.d_fe_sign        = null;
        this.data.d_stab_sign      = null;
        this.data.d_phosphate_sign = null;
    }
    this.view.render() ;
} ;


diagController.formController.onSpintouch = function(){
    var viewSpinlab = new VeloxWebView("views/diag", "popupSpinTouch", {bindObject: {}}) ;
    viewSpinlab.openInPopup({
        size:"medium",
        title: " "
    })  ;

    viewSpinlab.on("fetchResults",function(){
        viewSpinlab.updateData() ;
        this.view.longTask(function(done){
            bluetooth.getSpinlabBLEResults(function(err, measures){
                if(err){ 
                    if(err === "BT_NOT_ACTIVE"){
                        err = VeloxWebView.tr("diag.pleaseActivateBluetooth") ;
                    }
                    if(err === "MISSING_LOCATION_PERMISSION"){
                        err = VeloxWebView.tr("diag.pleaseActivateLocationService") ;
                    }
                    if(err === "NOT_FOUND"){
                        err = VeloxWebView.tr("diag.cantFindSpinTouch") ;
                    }
                    return done("UNEXPECTED ERROR : "+JSON.stringify(err)) ;
                }
                this.updateMeasureFromSpin(measures) ;
                viewSpinlab.close();
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

diagController.formController.onSpinlab = function(){
    this.view.longTask(function(done){
        this.view.updateData() ;
        this.api.api.velox_map.searchFirst({ code: "spinlabOptions", key: "spinlabOptions"}, function(err, mapResult){
            if(err){ return done(err) ;}
            done() ;
            var spinLabOptions = {} ;
            if(mapResult){
                spinLabOptions = mapResult.value ;
            }
            var viewSpinlab = new VeloxWebView("views/diag", "popupSpinlab", {bindObject: spinLabOptions}) ;
            viewSpinlab.openInPopup({
                size:"medium",
                title: " "
            })  ;
        
            function savePref(data, callback){
                var record = mapResult||{ code: "spinlabOptions", key: "spinlabOptions" };
                record.value = data;
                this.api.api.transactionalChanges([{action: mapResult?"update":"insert", table : "velox_map", record: record}], callback) ;
            } ;
        
            
            viewSpinlab.on("startDiag",function(){
                viewSpinlab.updateData() ;
                this.view.longTask(function(done){
                    savePref.bind(this)(spinLabOptions, function(err){
                        if(err){ return done(err) ;}
                        
                        var type = "";
                        var disinfectant = this.data.p_disinfectant ;
                        if(this.data.d_pool_or_spa === "SPA"){
                            disinfectant = this.data.s_disinfectant ;
                        }
                        if(disinfectant === "CHLORINE" || disinfectant === "OXYGEN"){
                            type = "chlorine" ;
                        }else if(disinfectant === "BROMINE") {
                            type = "bromine" ;
                        }else if(disinfectant === "SALT") {
                            type = "salt" ;
                        }

                        if(!type){
                            return done(this.view.tr("diag.error.pleaseChooseType"));
                        }
                        
                        window.native.spinlab.checkWlc(function(err){
                            if(err){
                                var message = err;
                                if(err === "MISSING_WLC"){
                                    message = VeloxWebView.tr("diag.shouldInstallWlc") ;
                                } else if(err === "SHOULD_UPDATE_WLC"){
                                    message = VeloxWebView.tr("diag.shouldUpdateWlc") ;
                                }
                                done();
                                return this.view.error(message, function(){
                                    window.native.spinlab.install() ;
                                }) ;
                            }
                            viewSpinlab.getBoundObject().running = true;
                            viewSpinlab.render();
                            window.native.spinlab.startAnalysis(type, spinLabOptions.disk, function(err, measures){
                                viewSpinlab.getBoundObject().running = false;
                                viewSpinlab.render();
                                if(err){ 
                                    if(err === "OFFLINE"){
                                        return done(this.view.tr("diag.error.OFFLINE")) ;
                                    } else if(err === "BUSY"){
                                        return done(this.view.tr("diag.error.BUSY")) ;
                                    } else if(err === "UPDATING"){
                                        return done(this.view.tr("diag.error.UPDATING")) ;
                                    } else if(err === "ERROR"){
                                        return done(this.view.tr("diag.error.ERROR")) ;
                                    } else if(err === "NO_VALUE"){
                                        return done(this.view.tr("diag.error.NO_VALUE")) ;
                                    } else if(err === "REQUIRES_UPDATE"){
                                        done() ;
                                        this.view.info(this.view.tr("diag.updateFirmware"), function(){
                                            this.view.longTask(function(done){
                                                viewSpinlab.getBoundObject().firmwareRunning = true;
                                                viewSpinlab.render();
                                                window.native.spinlab.updateFirmware(function(err){
                                                    viewSpinlab.getBoundObject().firmwareRunning = false;
                                                    viewSpinlab.render();
                                                    if(err){ return done(err) ; }
                                                    viewSpinlab.getBoundObject().running = true;
                                                    viewSpinlab.render();
                                                    window.native.spinlab.startAnalysis(type, spinLabOptions.disk, function(err, measures){
                                                        viewSpinlab.getBoundObject().running = false;
                                                        viewSpinlab.render();
                                                        if(err){
                                                            console.log("Spinlab error", err) ;
                                                            return done(this.view.tr("diag.spinlabError")) ;
                                                        }
                                                        this.updateMeasureFromSpin(measures) ;
                                                        viewSpinlab.close();
                                                        done() ;
                                                    }.bind(this)) ;
                                                }.bind(this)) ;
                                            }.bind(this)) ;
                                        }.bind(this)) ;
                                    } else {
                                        console.log("Spinlab error", err) ;
                                        return done(this.view.tr("diag.spinlabError")+"\n"+err) ;
                                    }
                                    return;
                                }
                                this.updateMeasureFromSpin(measures) ;
                                viewSpinlab.close();
                                done() ;
                            }.bind(this)) ;
                        }.bind(this)) ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
};



diagController.formController.onOpenPoolTester = function(ev){
    let popupData = {measures : [], allMeasures: [], pagination: []} ;
    var viewVisit = new VeloxWebView("views/pooltester", "poolesterPopup", {bindObject: popupData}) ;
    viewVisit.openInPopup({
        size:"medium",
        title: " "
    })  ;
    viewVisit.on("validate",function(ev){
        let measures = ev.data ;
        this.view.updateData() ;
        if(measures.chlorine != null){
            this.data.d_free_cl = measures.chlorine ;
            this.data.d_free_cl_sign = null;
        }
        if(measures.total_cl != null){
            this.data.d_total_cl = measures.total_cl ;
            this.data.d_total_cl_sign = null;
        }
        if(measures.alk != null){
            this.data.d_alk = measures.alk ;
            this.data.d_alk_sign = null;
        }
        if(measures.ph != null){
            this.data.d_ph = measures.ph ;
            this.data.d_ph_sign = null;
        }
        if(measures.stab != null){
            this.data.d_stab = measures.stab ;
            this.data.d_stab_sign = null;
        }
        if(measures.bromine != null){
            this.data.d_br = measures.bromine ;
            this.data.d_br_sign = null;
        }
        if(measures.oxygen != null){
            this.data.d_oxygen = measures.oxygen ;
            this.data.d_oxygen_sign = null;
        }

        if(measures.signs){
            if(measures.signs.bromine != null){
                this.data.d_br_sign        = measures.signs.bromine;
            }
            if(measures.signs.ph != null){
                this.data.d_ph_sign        = measures.signs.ph;
            }
            if(measures.signs.chlorine != null){
                this.data.d_free_cl_sign   = measures.signs.chlorine;
            }
            if(measures.signs.total_cl != null){
                this.data.d_total_cl_sign  = measures.signs.total_cl;
            }
            if(measures.signs.stab != null){
                this.data.d_stab_sign      = measures.signs.stab;
            }
            if(measures.signs.oxygen != null){
                this.data.d_oxygen_sign      = measures.signs.oxygen;
            }
            if(measures.signs.alk != null){
                this.data.d_alk_sign      = measures.signs.alk;
            }
        }
        this.view.render() ;

    }.bind(this)) ;
} ;


module.exports = diagController ;